/** Progressively enhance the native, keyboard-scrollable reading list. */
class RedLightReadingRail extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.learn-reading__rail');
    this.controls = this.querySelector('.learn-reading__controls');
    if (!this.list || !this.controls) return;
    this.previous = this.controls.querySelector('[data-direction="previous"]');
    this.next = this.controls.querySelector('[data-direction="next"]');
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.controls.hidden = false;
    this.controls.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      const step = this.list.firstElementChild.getBoundingClientRect().width + gap;
      this.list.scrollBy({
        left: button === this.next ? step : -step,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }, { signal });
    this.list.addEventListener('scroll', this.update, { passive: true, signal });
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.list);
    this.update();
  }

  update = () => {
    const max = this.list.scrollWidth - this.list.clientWidth;
    this.previous.disabled = this.list.scrollLeft <= 2;
    this.next.disabled = this.list.scrollLeft >= max - 2;
    this.controls.hidden = max <= 2;
  };

  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('rl-reading-rail')) {
  customElements.define('rl-reading-rail', RedLightReadingRail);
}
